// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1vR_v","header":"PatientBlock_header__1Frt5","label":"PatientBlock_label__1PjeO","option":"PatientBlock_option__31RZq"};